import type { StepUpRequest, ApiError } from '@/types';
import { ErrorService } from '@/error/error.service';
import { errorCodeOf, getJson } from '@/utils/http';

export class StepUpService {
  public async getStepUpRequest(requestId: string | null): Promise<StepUpRequest | ApiError> {
    try {
      return await getJson<StepUpRequest>(`/step-up/${requestId}`);
    } catch (e) {
      return ErrorService.getError('ibis', errorCodeOf(e));
    }
  }
}
